import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

export const collection = 'dictionaryAffectedWorkflows'
export const dictionaryAffectedWorkflowsSchema = new schemas.Entity(collection)

export const schema = new schemas.Array(dictionaryAffectedWorkflowsSchema)

type RequestParamsType = { connectorId: string; descriptorId: string }

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ connectorId, descriptorId }: RequestParamsType) =>
    callApi(
      `${apiBase}/dictionary/connectors/${connectorId}/actions/affected/${descriptorId}`,
      schema
    )
